// Pro's New team: the teams area's form (`features/teams`, `NewTeam`) inside Pro's shell, under the
// brand Pro is on; a team made opens in Pro (spec ui-perf/ui-switch-classic-simple-pro, PR e5b).
// Composed here: a feature never imports another; the composition root may.
import { createRoute, useNavigate } from "@tanstack/react-router";

import { ProPage } from "../features/studio2/ProPage";
import { studio2Route } from "../features/studio2/routes";
import { NewTeam } from "../features/teams/NewTeamScreen";

/** `pro/teams/new`: a team made opens Pro's way in, which asks for its first brand. */
export const studio2NewTeamRoute = createRoute({
  getParentRoute: () => studio2Route,
  path: "teams/new",
  component: function ProNewTeam() {
    const navigate = useNavigate();
    return (
      <ProPage>
        <NewTeam
          onCreated={(teamId) => navigate({ to: "/teams/$teamId/pro", params: { teamId } })}
        />
      </ProPage>
    );
  },
});
